import { Injectable } from '@angular/core';

/**
 * Tokens do "confiar neste dispositivo", um por identificação de login. Ficam no localStorage do
 * domínio do SSO: o backend só guarda o hash e confere prazo e revogação a cada login.
 */
@Injectable({
  providedIn: 'root'
})
export class DispositivoConfiavelService {
  private static readonly CHAVE = 'dispositivosConfiaveis';

  obter(usuario: string): string | null {
    const chave = this.normalizar(usuario);
    return chave ? this.ler()[chave] ?? null : null;
  }

  guardar(usuario: string, token: string): void {
    const chave = this.normalizar(usuario);
    if (!chave || !token)
      return;

    const tokens = this.ler();
    tokens[chave] = token;
    this.gravar(tokens);
  }

  remover(usuario: string): void {
    const chave = this.normalizar(usuario);
    const tokens = this.ler();
    if (!chave || !(chave in tokens))
      return;

    delete tokens[chave];
    this.gravar(tokens);
  }

  private normalizar(usuario: string): string {
    return (usuario ?? '').trim().toUpperCase();
  }

  // Navegação privada ou storage bloqueado: segue sem lembrar, o login pede o código normalmente.
  private ler(): Record<string, string> {
    try {
      return JSON.parse(localStorage.getItem(DispositivoConfiavelService.CHAVE)) ?? {};
    } catch {
      return {};
    }
  }

  private gravar(tokens: Record<string, string>): void {
    try {
      localStorage.setItem(DispositivoConfiavelService.CHAVE, JSON.stringify(tokens));
    } catch { }
  }
}
